module.exports = __webpack_public_path__ + "static/media/reinjection.95fd850d.webp";